import styles from './Spinner.module.css';

interface ISpinnerProps {
  visible?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Spinner = ({ visible = true, size = 'md', className = '' }: ISpinnerProps) => {
  if (!visible) return <></>;

  let spinnerClass = '';

  switch (size) {
    case 'sm':
      spinnerClass = styles.spinnerSmall;
      break;
    case 'lg':
      spinnerClass = styles.spinnerLarge;
      break;
    default:
      spinnerClass = styles.spinner;
  }

  return <div className={`${spinnerClass} ${className}`}></div>;
};

export default Spinner;
